export default "__VITE_ASSET__0a32013d__"